/* eslint-disable import/prefer-default-export */
import { GenericResponse } from 'services/api/base';

import {
  CultureIndexCulture,
  CultureIndexCultureResponse,
} from 'types/Meteorology/Agro/CultureIndex/culture';
import {
  CultureIndexPhenologicalStage,
  CultureIndexPhenologicalStageResponse,
} from 'types/Meteorology/Agro/CultureIndex/phenologicalStage';

export function transformGetCulturesResponse(
  response: CultureIndexCultureResponse,
): CultureIndexCulture[] {
  return response.data.map((culture) => ({
    name: culture.nome,
    label: culture.label,
  }));
}

export function transformGetPhenologicalStagesResponse(
  response: CultureIndexPhenologicalStageResponse,
): CultureIndexPhenologicalStage[] {
  return response.data.map((phenologicalStage) => ({
    name: phenologicalStage.nome,
    label: phenologicalStage.label,
  }));
}

export const transformGetDates = (response: GenericResponse<string[]>): string[] => response.data;
